// src/pages/SettingsPage.tsx
import React from "react";
import { Box, Divider, Stack, Title, ScrollArea, Text } from "@mantine/core";
import DrofusSettingsCard from "./DrofusSettings";
import ProjectBasicsCard from "./ProjectBasicsCard";
import { ClearValidationButton } from "./ClearValidationButton";
import VentilationSettingsCard from "./VentilationSettingsCard";
import DeviceTypesOverviewCard from "./DeviceTypesOverviewCard";

const SettingsPage: React.FC = () => {
  return (
    <ScrollArea.Autosize w="100%" mah="calc(100vh - 72px)" type="auto" offsetScrollbars>
      <Box maw={800} mx="auto" p={20} style={{ width: 800 }}>
        <Stack gap="lg">
          <Title order={3}>Prosjektinnstillinger</Title>

          {/* Grunninnstillinger */}
          <ProjectBasicsCard />

          <Divider label="Ventilasjon" />
          <VentilationSettingsCard />

          <Divider label="Device-typer" />
          <DeviceTypesOverviewCard />

          <Divider label="dRofus" />

          {/* dRofus-innstillinger */}
          <DrofusSettingsCard />

          <Divider label="Validering" labelPosition="left" />

          {/* Fjern valideringer */}
          <Stack gap="xs">
            <Title order={5}>Fjern drofus-valideringer</Title>
            <Text size="sm" c="dimmed">
              Fjern alle valideringer for dette prosjektet. Kan ikke angres.
            </Text>
            <ClearValidationButton />
          </Stack>
        </Stack>
      </Box>
    </ScrollArea.Autosize>
  );
};

export default SettingsPage;
